import React, { useEffect } from "react"
import { Table, Tag } from "antd"
import { connect } from "react-redux"
import ShopActions from "redux-store/models/shop"
import moment from "moment"

const OrdersShopAdminDomain = ({ ordersShop, getOrders }) => {
  useEffect(() => {
    getOrders()
  }, [getOrders])

  const parseData = (data) => {
    try {
      return data ? JSON.parse(data) : {}
    } catch (e) {
      return {}
    }
  }

  const columns = [
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => (date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : "-"),
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      key: "supplier",
    },
    {
      title: "Order ID",
      dataIndex: "order_id",
      key: "order_id",
    },
    {
      title: "Status",
      dataIndex: "status_description",
      key: "status_description",
      render: (text, record) => (
        <Tag color={record.status === 1 ? "orange" : "green"}>
          {text?.toUpperCase()}
        </Tag>
      ),
    },
  ]

  return (
    <div className="container-fluid overview ordersShop">
      <h5 style={{ padding: 10 }}>Ordini Shop</h5>

      <Table
        dataSource={ordersShop}
        scroll={{ y: "calc(100vh - 270px)" }}
        columns={columns}
        rowKey={(record) => record.id}
        pagination={{ pageSize: 10 }}
        expandedRowRender={(record) => {
          const data = parseData(record.data)
          const attrs = data?.attributes_json || {}

          return (
            <div className="order-expanded-grid">
              <div className="card-box">
                <div className="section-title">🛒 Product Details</div>

                <div className="row-item">
                  <span>SKU:</span>
                  <b>{data?.sku || "-"}</b>
                </div>

                <div className="row-item">
                  <span>Price:</span>
                  <b style={{ color: "#1890ff" }}>{data?.price || 0}€</b>
                </div>

                <div className="row-item">
                  <span>Supplier:</span>
                  <b>{record.supplier}</b>
                </div>

                <div className="section-subtitle">Attributes</div>

                <div className="chips">
                  {Object.keys(attrs).length > 0 ? (
                    Object.entries(attrs).map(([key, val]) => (
                      <span key={key} className="chip">
                        {key}: <b>{val}</b>
                      </span>
                    ))
                  ) : (
                    <span className="muted">No attributes</span>
                  )}
                </div>
              </div>

              <div className="card-box">
                <div className="section-title">📦 Order Info</div>

                <div className="row-item">
                  <span>User ID:</span>
                  <b>{record.user_id}</b>
                </div>

                <div className="row-item">
                  <span>Payment:</span>
                  <b>{record.payment_id}</b>
                </div>

                <div className="row-item">
                  <span>Tracking:</span>
                  <b>{record.tracking_number || "—"}</b>
                </div>

                <div className="row-item">
                  <span>Status:</span>
                  <Tag color={record.status === 1 ? "orange" : "green"}>
                    {record.status_description?.toUpperCase()}
                  </Tag>
                </div>
              </div>

              <div className="card-box">
                <div className="section-title">👤 User Info</div>

                <div className="row-item">
                  <span>Email:</span>
                  <b>{data?.shipping?.email || "-"}</b>
                </div>

                <div className="row-item">
                  <span>Phone:</span>
                  <b>{data?.shipping?.phone_number || "-"}</b>
                </div>

                <div className="row-item">
                  <span>City:</span>
                  <b>{data?.shipping?.city || "-"}</b>
                </div>

                <div className="row-item">
                  <span>Address:</span>
                  <b>{data?.shipping?.address || "-"}</b>
                </div>
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

const mstp = (state) => ({
  ordersShop: state.shop.ordersShop,
})

export default connect(mstp, ShopActions)(OrdersShopAdminDomain)
